(() => {
  const SELECTOR = '.jb-collection .jb-card__gallery[data-jb-gallery]';
  const MOBILE_QUERY = window.matchMedia('(max-width: 800px), (hover: none) and (pointer: coarse)');

  function initGallery(gallery, index) {
    if (gallery.dataset.jbGalleryReady === 'true') return;
    gallery.dataset.jbGalleryReady = 'true';

    const card = gallery.closest('.jb-card');
    const link = card ? card.querySelector('.jb-card__link') : null;
    let startX = 0;
    let startY = 0;
    let moved = false;
    let userInteracted = false;

    gallery.addEventListener('pointerdown', (event) => {
      startX = event.clientX;
      startY = event.clientY;
      moved = false;
      userInteracted = true;
      card?.classList.add('jb-card--is-dragging');
    }, { passive: true });

    gallery.addEventListener('pointermove', (event) => {
      if (Math.abs(event.clientX - startX) > 8 || Math.abs(event.clientY - startY) > 8) {
        moved = true;
      }
    }, { passive: true });

    gallery.addEventListener('pointerup', () => {
      card?.classList.remove('jb-card--is-dragging');
    }, { passive: true });

    gallery.addEventListener('pointercancel', () => {
      card?.classList.remove('jb-card--is-dragging');
    }, { passive: true });

    if (link) {
      link.addEventListener('click', (event) => {
        if (moved) {
          event.preventDefault();
          event.stopPropagation();
          moved = false;
        }
      });
    }

    // Only the first two cards demonstrate the gesture, once per page load.
    if (index > 1 || gallery.children.length < 2) return;

    const delay = index === 0 ? 650 : 1200;

    window.setTimeout(() => {
      if (!MOBILE_QUERY.matches || userInteracted || gallery.scrollLeft > 2) return;

      const hintDistance = Math.min(38, gallery.clientWidth * 0.12);
      if (hintDistance <= 0) return;

      gallery.scrollTo({ left: hintDistance, behavior: 'smooth' });

      window.setTimeout(() => {
        if (userInteracted) return;
        gallery.scrollTo({ left: 0, behavior: 'smooth' });
      }, 360);
    }, delay);
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
